import React from 'react';
import { Download } from 'lucide-react';

interface ReportExportButtonProps {
  onExcelExport: () => void;
  onPdfExport: () => void;
}

const ReportExportButton: React.FC<ReportExportButtonProps> = ({ onExcelExport, onPdfExport }) => {
  return (
    <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto justify-end">
      <button
        id="export-excel-button"
        onClick={onExcelExport}
        className="btn-primary flex items-center justify-center text-[24px] sm:text-[16px] rounded-full sm:text-body w-fit sm:w-auto sm:rounded-[8px]"
      >
        <span className=""><Download className="h-4 w-4" /></span>
        <span className="ml-1 hidden sm:inline">Excel</span>
      </button>
      <button
        id="export-pdf-button"
        onClick={onPdfExport}
        className="btn-primary flex items-center justify-center text-[24px] sm:text-[16px] rounded-full sm:text-body w-fit sm:w-auto sm:rounded-[8px]"
      >
        <span className=""><Download className="h-4 w-4" /></span>
        <span className="ml-1 hidden sm:inline">PDF</span>
      </button>
    </div>
  );
};

export default ReportExportButton;
